import {useEffect, useMemo, useRef, useState} from 'react'
import {CardAmount, MwInputText,BasicSelector, MwSpinner, MwButton, MwSpinnerButton } from '../ui';
import { useFetch,useCurrent, useInvoice } from '../../hooks';
import {CgAddR} from 'react-icons/cg'
import {RiDeleteBinLine} from 'react-icons/ri'
import {AiOutlineSave} from 'react-icons/ai'
import axios from 'axios';

const PayInvoice = ({netAmount,invId,invNo,onHide,onSubmitPay,type='out', currency, invoiceData, financeEndpoint}) => {
    const normalizedNetAmount = Math.max(0, Number(netAmount || 0));
    const [openList, setOpenList] = useState(false)
    const {currentTenantId,currentCompanyId,currentBranchId,currentLangId,userId} = useCurrent();
    const {data:dataPaymentMethod,loadingPaymentMethod,error} = useFetch(`${process.env.REACT_APP_INV_API_SERVER_BASE_URL}/payment-methods/${currentTenantId}/${currentCompanyId}/${currentBranchId}`)
    const [loadingConfirmPayment, setLoadingConfirmPayment] = useState(false)
    const [paymentMethod,setpaymentMethod] = useState([])
    const [selectedPaymentMethod,setSelectedPaymentMethod] = useState()
    const [payAmount,setPayAmount] = useState(normalizedNetAmount)
    const [remainingAmount,setRemainingAmount] = useState(normalizedNetAmount);
    const [listPayAmount,setListPayAmount] = useState([]);
    const [totalPay,setTotalPay] = useState(0);
    const isSubmittingRef = useRef(false);
    const {formatter, formatAmount} = useInvoice();
    const financeBaseUrl = useMemo(() => {
        if (process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL) {
            return process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL.replace(/\/+$/, '');
        }
        if (process.env.REACT_APP_INV_API_SALES_SERVER_BASE_URL) {
            return process.env.REACT_APP_INV_API_SALES_SERVER_BASE_URL.replace(/\/sales\/?$/, '/finance').replace(/\/+$/, '');
        }
        return `${(process.env.REACT_APP_API_URL || '').replace(/\/+$/, '')}/finance`;
    }, []);
    const shouldLinkInvoice = invId && invNo;
    const getSaudiToday = () =>
        new Intl.DateTimeFormat('en-CA', {
            timeZone: 'Asia/Riyadh',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        }).format(new Date());

    const onChangePaymentMethod = (value) => {
        console.log(value);
        setSelectedPaymentMethod(value)
    }

    const listHandler = () => {
        const seen = new Set();
        return dataPaymentMethod.reduce((acc, paymentMethod) => {
          if (paymentMethod.description?.length > 0) {
             const rawLabel =
              paymentMethod.description.find(des => des.lang === currentLangId)?.name ||
              paymentMethod.description[0]?.name;
            
             let normalizedLabel = rawLabel;
            if (rawLabel.includes(' - ')) {
              normalizedLabel = rawLabel
                .split(' - ')
                .map(item => item.trim())
                .sort()
                .join(' - ');
            }
      
             if (!seen.has(normalizedLabel)) {
              seen.add(normalizedLabel);
              acc.push({
                label: rawLabel,
                value: paymentMethod.id,
                treasurieId: paymentMethod.treasurie_id || paymentMethod.treasury_id || '',
              });
            }
          }
          return acc;
        }, []);
    }

    const removeHandler = (itemIndex) => {
        const filter = listPayAmount.filter((item,index) => index !== itemIndex)
        setListPayAmount(filter)
    }
    const addHandler = () => {
        const amountNumber = Number(payAmount || 0);
        const remainingNumber = Number(remainingAmount || 0);
        console.log(amountNumber, remainingNumber);
        if (!Number.isFinite(amountNumber) || amountNumber <= 0) return;
        if (!Number.isFinite(remainingNumber) || amountNumber > remainingNumber) return;
        

        const objPayAmounnt = {
            paymentMethodId: selectedPaymentMethod.value ,
            paymentMethodNName: selectedPaymentMethod.label ,
            treasurieId: selectedPaymentMethod.treasurieId || '',
            amount : amountNumber
        }
        console.log(totalPay,netAmount);
        if(amountNumber <= remainingNumber){
            setListPayAmount([...listPayAmount,objPayAmounnt])
        }
    }

    const createFinanceEntries = async (payments, headers) => {
        const eligible = payments.filter((item) => item?.treasurieId);
        if (eligible.length === 0) return;

        const normalizedType = String(type || '').trim().toLowerCase();
        const normalizedFinanceEndpoint = String(financeEndpoint || '').trim().toLowerCase();
        const isIncome = normalizedFinanceEndpoint
            ? normalizedFinanceEndpoint === 'incomes'
            : normalizedType === 'in';
        const entryDate = getSaudiToday();
        const moduleName = isIncome ? 'incomes' : 'expenses';
        const countResponse = await axios.get(
            `${financeBaseUrl}/${moduleName}/count/${currentTenantId}/${currentCompanyId}/${currentBranchId}/${encodeURIComponent(entryDate)}`,
            { headers }
        );
        const rawCount = Number(countResponse?.data?.data ?? countResponse?.data ?? 0);
        const startCode = Number.isFinite(rawCount) ? rawCount + 1 : 1;

        const partnerName = String(invoiceData?.customer_name || '').trim();
        const partnerId = String(invoiceData?.customer_id || '').trim();
        const invoiceVat = Number(invoiceData?.vat_amount || 0);
        const invoiceGross = Number(invoiceData?.net_amount || 0);
        const vatRatio = invoiceGross > 0 && invoiceVat > 0 ? invoiceVat / invoiceGross : 0;

        const requests = eligible.map((item, index) => {
            const amountValue = Number(item?.amount || 0);
            const amount = Number.isFinite(amountValue) ? amountValue : 0;
            const vatAmount = Number((amount * vatRatio).toFixed(2));
            const pureAmount = Number((amount - vatAmount).toFixed(2));
            const payload = {
                code: startCode + index,
                total_amount: pureAmount.toFixed(2),
                vat_amount: vatAmount.toFixed(2),
                total_amount_with_vat: amount.toFixed(2),
                desc: isIncome
                    ? `Invoice #${invNo} payment by ${item?.paymentMethodNName || ''}`
                    : `Invoice #${invNo} disbursement by ${item?.paymentMethodNName || ''}`,
                attach: '',
                seller_name: partnerName,
                tags: JSON.stringify([]),
                treasury_id: item.treasurieId,
                tax_type: '',
                repeat_period: 0,
                repeat_expire: '',
                tenant_id: currentTenantId,
                company_id: currentCompanyId,
                branch_id: currentBranchId,
                created_by: userId,
                details: [
                    {
                        to_account_no: '',
                        desc: isIncome ? `Payment for invoice #${invNo}` : `Disbursement for invoice #${invNo}`,
                        amount: pureAmount.toFixed(2),
                        tax_type: '',
                        to_cost_account_no: '',
                    },
                ],
            };

            if (isIncome) {
                payload.customer_id = partnerId;
                payload.customer_name = partnerName;
                payload.incomes_date = entryDate;
                payload.incomes_type_id = '';
            } else {
                payload.vendor_id = partnerId;
                payload.vendor_name = partnerName;
                payload.expense_date = entryDate;
                payload.expenses_type_id = '';
            }

            if (shouldLinkInvoice) {
                payload.inv_id = invId;
                payload.inv_no = invNo;
            }

            return axios.post(`${financeBaseUrl}/${moduleName}`, payload, { headers });
        });

        await Promise.all(requests);
    };

    const confirmPaymentHanndler = async () => {
        if (isSubmittingRef.current || loadingConfirmPayment || !listPayAmount.length) return;
        let _data = [];
        listPayAmount.map(list => {
            const _obj = {
                "transaction_no" : `trans-${invId}-${invNo}`,
                "amount" : list.amount,
                "type": type,
                "payment_method_id" : list.paymentMethodId,
                "notes" : "",
                "tenant_id" : currentTenantId,
                "company_id" : currentCompanyId,
                "branch_id" : currentBranchId,
                "created_by" : userId
            }
            if (shouldLinkInvoice) {
                _obj.inv_id = invId;
                _obj.inv_no = invNo;
            }
            _data.push(_obj)
        });
        const token = localStorage.getItem('token');
        const headers = {
            'Content-Type': 'application/json; charset=utf-8',
            Authorization: `Bearer ${token}`,
        };
        try {
            isSubmittingRef.current = true;
            setLoadingConfirmPayment(true);
            await axios.post(`${process.env.REACT_APP_INV_API_SERVER_BASE_URL}/payment-transactions`,_data,{ headers });
            await createFinanceEntries(listPayAmount, headers);
            onSubmitPay();
            onHide();
        } catch (e) {
            console.error(e);
        } finally {
            setLoadingConfirmPayment(false);
            isSubmittingRef.current = false;
        }
    }

    useEffect(()=>{
            const total = Number(listPayAmount.reduce((sum, obj) => Number(sum) + Number(obj.amount || 0),0));
            const remain = Math.max(0, Number(normalizedNetAmount - total));
                setTotalPay(total)
                setRemainingAmount(remain)
                setPayAmount(remain);
    },[listPayAmount, normalizedNetAmount]);

    useEffect(() => {
        if(dataPaymentMethod){
            setpaymentMethod(listHandler())
        }
    },[dataPaymentMethod])

    useEffect(() => {
        if(paymentMethod && paymentMethod.length === 1) {
            setSelectedPaymentMethod(paymentMethod[0]);
        }
    }, [paymentMethod]);

    useEffect(() => {
        if(dataPaymentMethod && dataPaymentMethod.length === 0) {
            onHide();
            onSubmitPay('no-payment-methods');
        }
    }, [dataPaymentMethod]);


    const ListPayAmount = listPayAmount.map((payAmount,index) => (
        <div key={index} className='flex justify-between items-center px-4 text-xs border-slate-300 border-b p-2'>
            <div className='w-8 text-center'>{index+1}</div>
            <div className='flex-1 '>{payAmount.paymentMethodNName}</div>
            <div className='font-bold w-24  text-center'>{ currency ? formatAmount(payAmount.amount, currency) : formatter.format(payAmount.amount) }</div>
            <div className='flex justify-center w-16 '>
                <RiDeleteBinLine 
                    onClick={()=>removeHandler(index)} 
                    title='Delete Payment' 
                    className='text-red-800 hover:text-red-500' 
                    />
            </div>
        </div>
    ));
    const cancelHandle = () => {
        onHide();
    }
    return (
        <>
            { !loadingPaymentMethod && dataPaymentMethod ? 
                <div className="flex flex-col justify-between  ">
                    <div className='flex p-3 justify-end '>
                        { onHide && <MwButton inGroup={true}  type='cancelBtn' onClick={cancelHandle}>الغاء</MwButton> }
                        { 
                            !loadingConfirmPayment ?
                                <MwButton 
                                    inGroup={true}  
                                    type='saveBtn' 
                                    disabled={ (!!totalPay && totalPay > 0 )? false : true} 
                                    onClick={confirmPaymentHanndler}>
                                    {` أعتمد الدفع  ${ totalPay == 0 ? '' : '('+totalPay+')' }`}
                                <AiOutlineSave size={18}/>
                                </MwButton> :
                                <MwSpinnerButton/>
                        }
                    </div>
                    <div className='flex justify-between items-center px-3 mx-3 py-7 my-3  bg-slate-200 rounded-lg '>
                        <CardAmount label={`المبلغ المطلوب`} amountValue={ currency ? formatAmount(normalizedNetAmount, currency) : formatter.format(normalizedNetAmount) }  />
                        <CardAmount label={`المبلغ المدفوع`} amountValue={ currency ? formatAmount(totalPay || 0, currency) : formatter.format(totalPay || 0) }  />
                        <CardAmount label={`المبلغ المتبقي`} amountValue={ currency ? formatAmount(parseFloat(remainingAmount?.toFixed(2) || 0), currency) : formatter.format(parseFloat(remainingAmount?.toFixed(2) || 0)) }  />
                    </div>
                    <div className='flex justify-between items-center p-3 bg-slate-200 rounded-lg m-3 ' >
                        <div className=' flex ' >
                            <MwInputText value={ payAmount  } inputType='number' onChange={(e) => setPayAmount(e.target?.value)} placeholder='Enter amount' />
                        </div>
                        <div className='flex-1 '>
                            <BasicSelector 
                                size='lg' 
                                listItem={paymentMethod}
                                onSelected={onChangePaymentMethod}
                                openList={openList}
                                setOpenList={setOpenList}
                                customStyle='bg-white'
                                >
                                {selectedPaymentMethod?.label || 'أختر طريقة الدفع'}
                            </BasicSelector>
                        </div>
                        <MwButton inGroup={true} type='saveBtn' disabled={ (selectedPaymentMethod && Number(payAmount) > 0 && Number(remainingAmount) > 0 )? false : true} size='sm' onClick={addHandler} ><CgAddR size={18}/>أضف</MwButton>
                    </div>
                    {ListPayAmount.length > 0 && <div className='bg-slate-200 rounded-lg m-3 py-3'>{ListPayAmount}</div> }
                </div> : 
            <MwSpinner/> }
        </>
    )
}

export default PayInvoice
